<div class="container-fluid">
  <div class="container container-shadow my-4" *ngIf="loading">
    <div class="text-center py-5">
      <i class="fas fa-spinner fa-3x fa-fw fa-pulse"></i>
    </div>
  </div>
  <div class="container container-shadow my-4 px-4 py-5" *ngIf="!loading">
    <h3>{{ toBePaid.vendor_name }}</h3>
    <hr class="my-2" />
    <div class="float-right">
      <div class="card">
        <div class="card-body">
          <table>
            <tbody>
              <tr>
                <td colspan="2">
                  <h4>Tree Totals</h4>
                </td>
              </tr>
              <tr>
                <td class="py-1 text-white">
                  <h4 class="bg-info py-1 px-2">Charge</h4>
                </td>
                <td class="py-1 text-white">
                  <h4 class="bg-info py-1 px-2">{{ tree[0].amount | currency: 'USD':'symbol-narrow':'1.2-2' }}</h4>
                </td>
              </tr>
              <tr>
                <td class="py-1 text-white">
                  <h4 class="bg-success py-1 px-2">Payment</h4>
                </td>
                <td class="py-1 text-white">
                  <h4 class="bg-success py-1 px-2">{{ tree[0].amount - toBePaid.balance | currency: 'USD':'symbol-narrow':'1.2-2' }}</h4>
                </td>
              </tr>
              <tr>
                <td class="py-1 text-white">
                  <h4 class="bg-warning py-1 px-2">Balance</h4>
                </td>
                <td class="py-1 text-white">
                  <h4 class="bg-warning py-1 px-2">{{ toBePaid.balance | currency: 'USD':'symbol-narrow':'1.2-2' }}</h4>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td colspan="2" class="text-center">
                <h5>
                  <div class="float-left" *ngIf="toBePaid.status != 'P' && toBePaid.bill_type_name != 'payment'">
                    <a [routerLink]="'/to_be_paids/' + toBePaid.id + '/edit'" class="btn btn-outline-primary"> Edit </a>
                  </div>
                  {{ toBePaid.bill_type_name }} -&nbsp;
                  <app-badge badgeType="warning" *ngIf="toBePaid.status == 'O'">
                    {{ toBePaid.status_name }}
                  </app-badge>
                  <app-badge badgeType="success" *ngIf="toBePaid.status == 'P'">
                    {{ toBePaid.status_name }}
                  </app-badge>
                  <app-badge badgeType="dark" *ngIf="toBePaid.status == 'V'">
                    {{ toBePaid.status_name }}
                  </app-badge>
                  <app-badge badgeType="danger" *ngIf="toBePaid.status == 'C'">
                    {{ toBePaid.status_name }}
                  </app-badge>
                </h5>
              </td>
            </tr>
            <tr>
              <td>{{ toBePaid.bill_type_name == 'charge' ? 'Amount' : 'Payment amount' }}</td>
              <td>{{ toBePaid.amount | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
            </tr>
            <tr>
              <td>{{ toBePaid.bill_type_name == 'charge' ? 'Paid' : 'Payment for' }}</td>
              <td>
                <span *ngIf="toBePaid.bill_type_name == 'charge'; else paymentElseBlock">{{ toBePaid.amount - toBePaid.balance | currency: 'USD':'symbol-narrow':'1.2-2' }}</span>
                <ng-template #paymentElseBlock>
                  <a target="_blank" [routerLink]="'/to_be_paids/' + tree[0].id">Charge: {{ tree[0].amount | currency: 'USD':'symbol-narrow':'1.2-2' }}</a>
                </ng-template>
              </td>
            </tr>
            <tr>
              <td>Balance</td>
              <td>{{ toBePaid.balance | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-sm-6">
        <table class="table">
          <tbody>
            <tr>
              <td>Date</td>
              <td [title]="toBePaid.created_at">{{ toBePaid.created_at_date }}</td>
            </tr>
            <tr>
              <td>Description</td>
              <td>
                <span *ngIf="!toBePaid.is_charge && toBePaid.check_number">Check&nbsp;#</span><a *ngIf="toBePaid.document_url" [href]="toBePaid.document_url">{{ toBePaid.document_text }}</a>
                <span *ngIf="!toBePaid.document_url && toBePaid.document_text">{{ toBePaid.document_text }}</span>
                <span *ngIf="!toBePaid.document_url && !toBePaid.document_text && toBePaid.bill_type_name == 'payment'" class="text-warning">None</span>
                <span *ngIf="!toBePaid.document_url && !toBePaid.document_text && toBePaid.bill_type_name == 'charge'" class="text-muted">N/A</span>
                <br *ngIf="toBePaid.description" />
                <span class="text-secondary">{{ toBePaid.description }}</span>
              </td>
            </tr>
            <tr>
              <td>Account #</td>
              <td>{{ toBePaid.vendor_account_number }}</td>
            </tr>
            <tr>
              <td>Matter</td>
              <td>
                <a target="_blank" [href]="'/matters/' + 'toBePaid.matter_id'">{{ toBePaid.matter_name }}</a>
              </td>
            </tr>
            <tr>
              <td>Chart of account</td>
              <td>{{ toBePaid.chart_of_account_name }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <br />
    <div class="clearfix"></div>
    <h3 class="mb-3">Tree</h3>
    <table class="table">
      <thead>
        <tr>
          <th>Date</th>
          <th>Document</th>
          <th>Status</th>
          <th>Type</th>
          <th>Charge</th>
          <th>Payment</th>
          <th>Balance</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let toBePaidItem of tree">
          <td (mouseenter)="toBePaidItem.hovering = true" (mouseleave)="toBePaidItem.hovering = false" style="min-width: 92px !important" [title]="toBePaidItem.created_at">
            <a *ngIf="toBePaidItem.hovering && toBePaidItem.status != 'P'" [routerLink]="'/to_be_paids/' + toBePaidItem.id + '/edit'">
              <i class="fas fa-pencil-alt"></i>
            </a>
            <span *ngIf="toBePaidItem.hovering">&nbsp;</span>
            <a [routerLink]="'/to_be_paids/' + toBePaidItem.id">
              {{ toBePaidItem.created_at_date }}
            </a>
          </td>
          <td style="width: 30%">
            <span *ngIf="!toBePaidItem.is_charge && toBePaidItem.check_number">Check&nbsp;#</span><a *ngIf="toBePaidItem.document_url" [href]="toBePaidItem.document_url">{{ toBePaidItem.document_text }}</a>
            <span *ngIf="!toBePaidItem.document_url && toBePaidItem.document_text">{{ toBePaidItem.document_text }}</span>
            <span *ngIf="!toBePaidItem.document_url && !toBePaidItem.document_text && toBePaidItem.bill_type_name == 'payment'" class="text-warning">None</span>
            <span *ngIf="!toBePaidItem.document_url && !toBePaidItem.document_text && toBePaidItem.bill_type_name == 'charge'" class="text-muted">N/A</span>
            <br *ngIf="toBePaidItem.description" />
            <span>{{ toBePaidItem.description }}</span>
          </td>
          <td>
            <app-badge *ngIf="toBePaidItem.status_name" [badgeType]="statusName(toBePaidItem.status_name)" style="width: 100% !important">{{ toBePaidItem.status_name }}</app-badge>
          </td>
          <td>
            {{ toBePaidItem.bill_type_name }}
          </td>
          <td>
            <span *ngIf="toBePaidItem.is_charge">{{ toBePaidItem.amount | currency: 'USD':'symbol-narrow':'1.2-2' }}</span>
          </td>
          <td>
            <span *ngIf="toBePaidItem.is_payment">{{ toBePaidItem.amount | currency: 'USD':'symbol-narrow':'1.2-2' }}</span>
          </td>
          <td>
            <span>{{ toBePaid.balance | currency: 'USD':'symbol-narrow':'1.2-2' }}</span>
          </td>
          <td>
            <i class="fas fa-exclamation-circle text-danger" *ngIf="toBePaidItem.is_priority"></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
